<template>
  <div>
    <el-dialog :fullscreen="true"
               append-to-body
               title="图片查看器"
               custom-class="task-review-evidence-dialog dark"
               @close="()=>this.$emit('close')"
               :visible.sync="visible">
    <div class="tred-container">
      <div class="tred-container-left">
        <view-image
          :visible="visible"
          ref="viewImage"
          :index="index"
          @changeIndex="onImageChanged"
          :files="images"
          :toolbar="{}"/>
      </div>
      <div class="tred-container-right"
           v-loading="isloadingRightBar">
        <div>
          <b>基础信息</b>
          <p>工单ID: {{imageDetail.image.orderid}}</p>
          <p>客户: {{imageDetail.customer.name}}/{{imageDetail.customer.id}}</p>
          <p>项目名称: {{imageDetail.project.name}}/{{imageDetail.project.number}}</p>
          <p>批次名称: {{imageDetail.batch.detail}}</p>
          <p>拍摄时间: {{imageDetail.image.created_at}}</p>
          <p>模板标题: Q{{imageDetail.step.index}}-{{imageDetail.step.title}}</p>
          <p>提交用户: {{imageDetail.orderDetail.userid}}</p>
          <p>状态: {{statusLabel}}</p>
        </div>
        <div>
          <b>审核日志</b>
          <div v-if="imageDetail.image.operation_logs.length > 0">
            <p v-for="log in imageDetail.image.operation_logs">{{log}}</p>
          </div>
          <div v-else>
            <p>
              暂无审核日志。
            </p>
          </div>
        </div>
        <div>
          <el-button type="success" @click="setImageResult(3)">非翻拍</el-button>
          <el-button type="danger" @click="setImageResult(4)">确认翻拍</el-button>
        </div>
      </div>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import '@views/question-review/question-review.scss'
import ViewImage from '@/views/question-review/components/AnswerFileFullScreen/src/ViewImage'
import ImageRecaptureDetectionMixins from '../order-image-recapture-detection.mixins'

export default {
  components: {ViewImage},
  mixins: [ImageRecaptureDetectionMixins],
  props: {
    images: Array
  },
  data () {
    return {
      index: 0,
      visible: false,
      currentIndex: null,
      imageDetail: {
        image: {
          status: null,
          orderid: null,
          created_at: null,
          operation_logs: [],
        },
        step: {},
        customer: {},
        project: {},
        batch: {},
        orderDetail: {},
      },
      statusLabel: null,
      isloadingRightBar: true,
    }
  },
  watch: {
    imageDetail (val) {
      this.statusLabel = this.getStatusLabel(val.image.result)
    }
  },
  methods: {
    open (index) {
      this.visible = true
      this.index = index

      this.loadRightBarData(index)
    },
    onImageChanged (index) {
      if (this.index !== index) {
        this.loadRightBarData(index)
      }
    },
    loadRightBarData (index) {
      this.isloadingRightBar = true
      let image = this.images[index]
      request.page('getOrderImageRecaptureDetectionImageDetail', {id: image.id}).then(({data}) => {
        this.index = index
        this.imageDetail = data
        this.isloadingRightBar = false
      })
    },
    setImageResult (result) {
      request.common('setOrderImageRecaptureDetectionImageStatus', {
        image_ids: [this.imageDetail.image.id],
        result
      }).then(() => {
        this.$message.success('设置成功')
        this.loadRightBarData(this.index)
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.tred-container {
  display: flex;
  height: 100%;

  &-left {
    width: calc(100% - 350px);
    position: relative;
  }

  &-right {
    padding: 20px;
    width: 350px;
    overflow: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-image-recapture-detection/components/ImageDetailDialog.vue